import { defineMessages } from 'react-intl'

export const MISC_MESSAGES = defineMessages({
  kids: { id: "constants.Messages.misc.MISC_MESSAGES.kids.5e54", defaultMessage: `{kids, plural,
      one {# ребенок}
      few {# ребенка}
      other {# детей}}` },
  babies: { id: "constants.Messages.misc.MISC_MESSAGES.babies.5e54", defaultMessage: `{babies, plural,
      one {# младенец}
      few {# младенца}
      other {# младенцев}}` },
  hours: { id: "constants.Messages.misc.MISC_MESSAGES.hours.5e54", defaultMessage: `{hour, plural,
      one {# час}
      few {# часа}
      other {# часов}}` },
  hoursWithMinutes: { id: "constants.Messages.misc.MISC_MESSAGES.hoursWithMinutes.5e54", defaultMessage: `{hour, plural,
      =0 {}
      one {# час }
      few {# часа }
      other {# часов }}{minutes, plural,
      =0 {}
      one {# минута}
      few {# минуты}
      other {# минут}}` },
  hoursWithMinutesShort: { id: "constants.Messages.misc.MISC_MESSAGES.hoursWithMinutesShort.5e54", defaultMessage: `{hour, plural,
      =0 {}
      other {# ч }}{minutes, plural,
      =0 {}
      other {# м}}` },
  km: { id: "constants.Messages.misc.MISC_MESSAGES.km.cc52", defaultMessage: '{distance}км' },
  m: { id: "constants.Messages.misc.MISC_MESSAGES.m.985a", defaultMessage: '{distance, number, distance}м' },
  age: { id: "constants.Messages.misc.MISC_MESSAGES.age.5e54", defaultMessage: `{age, plural,
        one {# год}
        few {# года}
        other {# лет}}` },
  months: { id: "constants.Messages.misc.MISC_MESSAGES.months.5e54", defaultMessage: `{value, plural,
        one {# месяц}
        few {# месяца}
        other {# месяцев}}` },
  less_than_month: { id: "constants.Messages.misc.MISC_MESSAGES.less_than_month.8acd", defaultMessage: 'Меньше месяца' },
  accurate_age: { id: "constants.Messages.misc.MISC_MESSAGES.accurate_age.5e54", defaultMessage: `{lessThanMonth, select,
      true {меньше месяца}
      other {{hasYears, select,
        true
          {{years, plural,
            one {# год}
            few {# года}
            other {# лет}
          }}
        other {}
        }{hasMonths, select,
          true
          {{hasYears, select,
            true {, }
            other {}
          }{months, plural,
            one {# месяц}
            few {# месяца}
            other {# месяцев}
          }}
        other {}}}}` },
  opinions: { id: "constants.Messages.misc.MISC_MESSAGES.opinions.5e54", defaultMessage: `{opinions, plural,
      =0 {нет отзывов}
      one {# отзыв}
      few {# отзыва}
      other {# отзывов}}` },
  finishSchool: { id: "constants.Messages.misc.MISC_MESSAGES.finishSchool.5e54", defaultMessage: `{gender, select,
      m {прошел школу Kidsout}
      f {прошла школу Kidsout}
      other {прошел(а) школу Kidsout}}` },
  supervise_chat_disabled: { id: "constants.Messages.misc.MISC_MESSAGES.supervise_chat_disabled.d937", defaultMessage: 'Чаты отключены. Просмотреть сообщения можно в админке.' },
  error_occured: { id: "constants.Messages.misc.MISC_MESSAGES.error_occured.3e11", defaultMessage: 'Произошла ошибка' },
})
